module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAJ1BMVEVHcExmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZKNJ7+AAAADHRSTlMAVfyC+4GDgFYBnIW+i5pQAAAAU0lEQVQ4y2NgGAV4AdtOHBI5p7CLM59xxC5hc0SAWhoUsWuIOYRdAyvVNNQcasAqzn5GgzQNOK3GbTc5WmxwacEZ6DhDnU5a2HBqwZXgcCfRYQgA6G0ek0obl4oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/back.png
// module id = i+Im
// module chunks = 37